<template>
  <div style="height:100%;width:100%">
    <div id="schjMap">
      <div class="rightSide0" :class="{ rightclose0: !bottBox }">
        <div class="titlebox">{{ dw }}</div>
        <label @mousedown.stop.prevent>
          <el-slider
            v-model="slidValue"
            vertical
            range
            :max="smax"
            :marks="smarks"
            @change="change"
            height="120px"
          >
          </el-slider>
        </label>
      </div>
      <img class="location" src="~images/schj/location.png" @click="location" />
      <img
        src="@/assets/images/schj/tozb.png"
        @click="toZb"
        alt=""
        class="btm-zb"
      />
    </div>
    <right-side>
      <el-row>
        <el-input
          v-model="input"
          placeholder="请输入检索名称"
          id="companysearch"
          class="companysearch"
          @input="inputResult"
        ></el-input>
      </el-row>
      <div class="sidenav">
        <div
          class="address"
          v-for="(item, index) in companyList"
          :key="index"
          @click="position(item, index)"
        >
          <div class="comList">
            <span class="circle" />
            <el-tooltip
              v-if="showTooltip(item.name)"
              class="item"
              effect="dark"
              :content="item.name"
              placement="top"
              :enterable="false"
            >
              <div class="companyName">
                <span>{{ item.name }}</span>
              </div>
            </el-tooltip>
            <div v-else class="companyName">
              <span>{{ item.name }}</span>
            </div>
            <!-- <img :src="item.imageUrl" /> -->
          </div>
        </div>
      </div>
    </right-side>
  </div>
</template>
<script>
import Vue from "vue";
import { loadChart } from "./scData";
import * as L from "leaflet";
import "proj4";
import "proj4leaflet";
const esri = require("esri-leaflet");
import "leaflet/dist/leaflet.css";
import "@/assets/css/schj.css";
import {
  getDataPriceTjByDataMarketNameAndYear,
  findDataMarketForKindByDate,
  findDataPriceBydataKindIdAndYear
} from "@/api/schj";
import "leaflet-echarts/dist/leaflet-echarts";
import "leaflet-echarts/lib/echarts.source";
import "leaflet.heat";
// 解决 leaflet 默认 maker 无法显示的问题
let DefaultIcon = L.icon({
  // iconUrl: require("images/ico_xm_0-50.png"),
  iconUrl: require("images/hq.png"),
  iconSize: [30, 30], // 加上，fixed marker在放缩5 时偏差比较大的问题
  iconAnchor: [3, 40],
  popupAnchor: [0, -50]
});
L.Marker.prototype.options.icon = DefaultIcon;
export default {
  name: "schj",
  data() {
    return {
      slidValue: [1, 100],
      smarks: { 0: "0", 100: "100" },
      smax: 100,
      dw: "元/公斤",
      bottBox: true,
      schjMap: null,
      ditu: null,
      popup: null,
      qypopup: null, // 企业信息弹出
      clatlng: null,
      main1Name: "全国销售排行",
      geoMarks: [],
      firstLoad: true,
      companyList: [],
      chooseIndex: 0,
      input: ""
    };
  },
  computed: {
    curcode() {
      return this.$store.state.schj.code;
    },
    cName() {
      return this.$store.state.schj.cname;
    },
    cMonth() {
      return this.$store.state.schj.cmonth;
    },
    dataKindId() {
      return this.$store.state.schj.dataKindId;
    }
  },
  watch: {
    cName() {
      if (!this.firstLoad) {
        this.loadXsjg();
      }
    },
    cMonth() {
      if (!this.firstLoad) {
        this.loadXsjg();
      }
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.chartResize);
  },
  mounted: function() {
    this.init();
    window.addEventListener("resize", this.chartResize);
  },
  methods: {
    toZb() {
      this.$store.dispatch("schj/setCode", "zb");
    },
    showTooltip(item) {
      if (window.innerWidth === 1366 && item.length > 15) return true;
    },
    inputResult() {
      findDataMarketForKindByDate({
        kindId: this.dataKindId,
        date: this.cMonth,
        name: this.input
      }).then(res => {
        this.companyList = res.data;
      });
    },
    init() {
      this.initMap();
      this.loadXsjg();
    },
    initMap() {
      let CRS_china_3857 = new L.Proj.CRS(
        "EPSG:3857",
        "+proj=merc +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=6378137 +b=6378137 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
        {
          resolutions: [
            156543.03392800014,
            78271.51696399994,
            39135.75848200009,
            19567.87924099992,
            9783.93962049996,
            4891.96981024998,
            2445.98490512499,
            1222.992452562495,
            611.4962262813797,
            305.74811314055756,
            152.87405657041106,
            76.43702828507324,
            38.21851414253662,
            19.10925707126831,
            9.554628535634155,
            4.77731426794937,
            2.388657133974685,
            1.1943285668550503,
            0.5971642835598172,
            0.29858214164761665
          ],
          origin: [-2.0037508342787e7, 2.0037508342787e7]
        }
      );
      this.schjMap = L.map("schjMap", {
        src: CRS_china_3857,
        minZoom: 4,
        maxZoom: 12,
        zoomControl: false
      }).on("click", ev => {
        this.clatlng = ev.latlng;
      });

      let tileMapLayer = esri.tiledMapLayer({
        url: this.$config.schjLxMap
      });
      tileMapLayer.addTo(this.schjMap);
      //this.schjMap.setView(L.latLng(35.137879119634185, 97.16308593750001), 5);
      this.location();
      window.schjmap = this.schjMap;
      //去掉右下标 商标
      setTimeout(() => {
        // eslint-disable-next-line no-undef
        $(".leaflet-control-attribution").empty();
      }, 300);
    },
    loadXsjg() {
      if (this.ditu) {
        this.schjMap.removeLayer(this.ditu);
        this.ditu = null;
      }
      findDataMarketForKindByDate({
        kindId: this.dataKindId,
        date: this.cMonth
      }).then(res => {
        this.companyList = res.data;
        let valueArr = [];
        res.data.map(v => {
          valueArr.push(v.price);
        });
        let smax = Math.max.apply(null, valueArr);
        this.smax = smax;
        this.smarks = { 0: "0", [smax]: smax.toString() };
        this.slidValue = [0, smax];
        const chinamapdata = res.data;
        if (chinamapdata) {
          // 构造geojson
          this.geoMarks = chinamapdata.map(data => {
            data.num = data.price;
            return {
              type: "Feature",
              properties: data,
              geometry: {
                type: "Point",
                coordinates: [data.longitude, data.latitude]
              }
            };
          });
          this.createMarkersForMk(this.geoMarks);
        }
      });
      this.initEct();
      this.firstLoad = false;
    },
    change() {
      const min = this.slidValue[0];
      const max = this.slidValue[1];
      // 修正marks
      this.smarks = {};
      this.smarks[min] = min + "";
      this.smarks[max] = max + "";

      // 处理市场价格过滤
      const _markerData = [];
      this.geoMarks.forEach(ele => {
        const num = Number(ele.properties.num);
        if (num > min && num <= max) {
          _markerData.push(ele);
        }
      });
      this.schjMap.removeLayer(this.ditu);
      this.createMarkersForMk(_markerData);
    },
    initEct() {
      // 加载echarts
      let _ydata = []; // 名称
      let _sdata = [];
      findDataPriceBydataKindIdAndYear({
        dataKindId: this.dataKindId,
        year: this.cMonth
      }).then(res => {
        if (res.data.length !== 0) {
          this.noChart1 = false;
          res.data.map(v => {
            _ydata.push(v.name);
            _sdata.push(v.value);
          });
        }
      });
    },

    getLat() {
      if (this.clatlng) {
        return this.clatlng;
      }
      return this.schjMap.getCenter();
    },
    position(item) {
      const name = item.name;
      const id = item.id;
      const price = item.num;
      // 创建ext
      let MyComponent = Vue.extend({
        template: `<div style="height:331px;"><div class="titlePan">{{name}}</div>
            <div style="width: 380px; height: 100%; padding:10px;" id="popmarker-jk10086"></div>
            </div>`,
        data() {
          return {
            name: name
          };
        }
      });
      let component = new MyComponent().$mount();
      if (this.qypopup == null) {
        this.qypopup = L.popup({
          minWidth: 400,
          className: "jk-popup",
          autoPanPadding: L.point(60, 152),
          offset: L.point(12, -32)
        })
          .setLatLng(this.getLat())
          .openOn(this.schjMap);
      }
      item.latLng = {
        lat: parseFloat(item.latitude),
        lng: parseFloat(item.longitude)
      };
      this.qypopup
        .setLatLng(item.latLng)
        .setContent(component.$el)
        .openOn(this.schjMap);
      setTimeout(() => {
        this.echarttu_marker("-jk10086", name, price, id);
      }, 200);
    },
    createMarkersForMk(chinamapdata) {
      // 使用默认icon create marker for 市场价格
      const _data0 = {
        type: "FeatureCollection",
        features: chinamapdata,
        crs: {
          type: "name",
          properties: { name: "EPSG:4326" } // EPSG4326
        }
      };
      this.ditu = L.geoJson(_data0, {
        //每个点击事件
        onEachFeature: (feature, layer) => {
          if (feature.properties && feature.properties.name) {
            layer.bindTooltip(
              // cname + ":" + feature.properties.num + "元/公斤",
              "<div style='font-size:14px;color:#e10b0b'>" +
                feature.properties.num +
                "</div>",
              {
                direction: "top",
                offset: L.point(10, -36),
                permanent: true
              }
            );
          }
        }
      });
      this.ditu.addTo(this.schjMap).on("click", e => {
        //当前点击的物体的名称
        const name = e.layer.feature.properties.name;
        const id = e.layer.feature.properties.id;
        const price = e.layer.feature.properties.num;
        // 创建ext
        let MyComponent = Vue.extend({
          template: `<div style="height:331px;"><div class="titlePan">{{name}}</div>
            <div style="width: 380px; height: 260px; padding:10px;" id="popmarker-jk10086"></div>
            </div>`,
          data() {
            return {
              name: name
            };
          }
        });
        let component = new MyComponent().$mount();
        if (this.qypopup == null) {
          this.qypopup = L.popup({
            minWidth: 400,
            className: "jk-popup",
            // autoPanPadding: L.point(window.screen.width * 0.27, 180),
            autoPanPadding: L.point(60, 152),
            offset: L.point(12, -32)
          })
            .setLatLng(this.getLat())
            .openOn(this.schjMap);
        }
        this.qypopup
          .setLatLng(e.latlng)
          .setContent(component.$el)
          .openOn(this.schjMap);
        setTimeout(() => {
          this.echarttu_marker("-jk10086", name, price, id);
        }, 200);
      });
    },
    async echarttu_marker(e, name, num) {
      // 12个月份销量 demo => 前后两年
      const res = await getDataPriceTjByDataMarketNameAndYear({
        marketName: name,
        year: 2020
      });
      const res2 = await getDataPriceTjByDataMarketNameAndYear({
        marketName: name,
        year: 2021
      });

      let date = Array.from(Array(12), (v, k) => k + 1);
      let value = Array.apply(null, Array(12)).map(function() {
        return null;
      });
      let value2 = Array.apply(null, Array(12)).map(function() {
        return null;
      });

      res.data.forEach(v => {
        let str = v.date.replace(/[\d]{4}-[0]?/, "");
        value[Number(str) - 1] = Number(parseFloat(v.price).toFixed(2));
      });
      res2.data.forEach(v => {
        let str = v.date.replace(/[\d]{4}-[0]?/, "");
        value2[Number(str) - 1] = Number(parseFloat(v.price).toFixed(2));
      });
      console.log("res", res, num);
      console.log("date", date);
      console.log("value", value);
      console.log("value2", value2);

      const myChart2 = this.$echarts.init(
        document.getElementById("popmarker" + e)
      );
      loadChart(myChart2, ["2020", "2021"], date, [value, value2], "元/公斤");
      /* let option = {
          top: 6,
          left: 8,
          title: {
            text: name + "最新价格:" + num + "元/公斤",
            textStyle: {
              fontSize: 14
            }
          },
          grid: {
            left: "10%",
            top: "18%",
            right: "1%",
            bottom: "10%"
            // containLabel: true
          },
          tooltip: {
            trigger: "axis",
            formatter: "{b} <br/>{a} : {c} 元/公斤"
          },
          xAxis: [
            {
              type: "category",
              data: date,
              axisLine: {
                lineStyle: {
                  color: "#999"
                }
              }
            }
          ],
          yAxis: [
            {
              type: "value",
              splitNumber: 4,
              splitLine: {
                lineStyle: {
                  type: "dashed",
                  color: "#DDD"
                }
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: "#333"
                }
              },
              nameTextStyle: {
                color: "#999"
              },
              splitArea: {
                show: false
              }
            }
          ],
          series: [
            {
              name: name + "",
              type: "line",
              data: value,
              lineStyle: {
                normal: {
                  width: 2,
                  color: {
                    type: "linear",

                    colorStops: [
                      {
                        offset: 0,
                        color: "#A9F387" // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#48D8BF" // 100% 处的颜色
                      }
                    ],
                    globalCoord: false // 缺省为 false
                  },
                  shadowColor: "rgba(72,216,191, 0.3)",
                  shadowBlur: 10,
                  shadowOffsetY: 20
                }
              },
              itemStyle: {
                normal: {
                  color: "#fff",
                  borderWidth: 4,
                  //   shadowColor: 'rgba(72,216,191, 0.3)',
                  // shadowBlur: 100,
                  borderColor: "#A9F387"
                }
              },
              smooth: true
            }
          ]
        };
        myChart2.setOption(option); */
    },
    location() {
      this.schjMap.setView(L.latLng(38.44491421192701, 104.150390625), 4);
      //this.schjMap.setView(L.latLng(35.137879119634185, 97.16308593750001), 5);
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~styl/largeScreen/schj'
@import '~styl/smallScreen/schj'

.rightSide
  right 27%

.rightSide0
  right calc(27% + 420px)

.location
  right calc(27% + 480px)
.btm-zb
    position absolute
    left 28%
    bottom 3vh
    cursor pointer
    z-index 401
</style>
